// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "PageHeader-module--bx--text-truncate--end--2YQt4";
export var bxTextTruncateFront = "PageHeader-module--bx--text-truncate--front--tZ7wT";
export var darkMode = "PageHeader-module--dark-mode--1snw_";
export var pageHeader = "PageHeader-module--page-header--PZk0n";
export var text = "PageHeader-module--text--1JBrD";
export var withTabs = "PageHeader-module--with-tabs--23d0d";